module.exports = __webpack_public_path__ + "static/media/minute-maid-apple.3a8d8fc1.jpg";